import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IShortNameField {
	changeShortName: (value: string) => void;
}

const ShortNameField: React.FC<IShortNameField> = ({ changeShortName }) => {
	const [validValue, setValidValue] = useState<string>('');
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterShortName') }], [t]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		if (/^k$|^kt$|^kt-$|^kt-(?!-)(?!.*--)[a-z0-9-]*$/.test(value) || value === '') {
			setValidValue(value);
			changeShortName(value);
			return value;
		}
		changeShortName(validValue);
		return validValue;
	};

	const handleBlur = () => {
		const match = validValue.match(/^kt-(?!.*--)(?:[a-z0-9]+-)*[a-z0-9]+$/);
		if (match) {
			const value = validValue.slice(3).replace(/-/g, '');
			value.length >= 3 ? changeShortName(validValue) : changeShortName('');
			return value.length >= 3 ? validValue : '';
		}
		if (validValue) {
			setValidValue('');
			changeShortName('');
			return '';
		}
	};

	return (
		<FormInput
			testId="ShortNameField"
			name="shortName"
			label="shortNameLabel"
			placeholder="kt-[a-z0-9]"
			getValueFromEvent={handleChange}
			onBlur={handleBlur}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ShortNameField);
